/*
  Custom sleeve message - Zepto app detection
  implemented: layout/theme.liquid
*/

document.addEventListener("DOMContentLoaded", function () {
  function whenAvailable(DOM_element, callback, number_of_trys) {
      number_of_trys += 1;
      const appEl = document.querySelector(DOM_element)
      const interval = 1000; 
    
      console.log( number_of_trys)
      const int = window.setTimeout(function() {
          if (appEl) {
              callback(appEl);
              clearInterval(int)
          } else {
             number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys", number_of_trys);
          }
      }, interval);
    }
  
  whenAvailable(".product-personalizer", function(el) {
   //alert("Zepto app loaded")
   console.log("Zepto app loaded", el)

  const zepto_container = document.querySelector('[data-js-zepto-container]')
  const zepto_btn = document.querySelector('.pplr-c-button')
  if(!zepto_container){
     return console.log('Cant find zepto container for custom sleeve message')
   } 
  zepto_container.appendChild(el)
  zepto_btn ? zepto_btn.innerText = `${zepto_btn.innerText} +19.95` : null;
  el.classList.add('loaded')  
   
  

  }, 0);

  // Hide zepto button for invalid variants (black, brown, red) -> first render
  const garment_color = document.querySelector('.product-block-variant-picker [x-text="options[2]"]')
  
  if(!garment_color){
     return console.log('Cant find garment color for custom sleeve message')
  }
  
  const zepto_btn = document.querySelector('.product-personalizer')
  const invalid_colors = ['Black', 'Brown (Limited Edition)', 'Red (Limited Edition)']

  if(invalid_colors.includes(garment_color.innerText)){
    zepto_btn?.classList?.add('invalid-variant')
  }
  
   // Hide zepto button for invalid variants (black, brown, red) -> onChange
  const config = { attributes: true, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        //console.log("A child node has been added or removed.", mutation.target.innerText);
        const current_color = mutation.target.innerText
       
       
        
        if(invalid_colors.includes(current_color)){
          zepto_btn?.classList?.add('invalid-variant')
        }else{
          zepto_btn?.classList?.remove('invalid-variant')
        }
        
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(garment_color, config);
  
  // Later, you can stop observing
  //observer.disconnect();




   
})

